import { instance, setHeader } from "./auth-api";
import { LOG_IN_TOKEN } from "../reducers/types";

const ACCOUNTIOAPI = `static`;

const getAccountioSimple = async (ep) => {
  const result = await instance.get(`${ACCOUNTIOAPI}/${ep}`, {
    headers: setHeader(LOG_IN_TOKEN),
  });
  return [ep, result];
};

const getCalculationRates = () => {
  return getAccountioSimple("calculationrates");
};

const getCountryRates = () => {
  return getAccountioSimple("countryrates");
};

const getCountries = () => {
  return getAccountioSimple("country");
};

const getMarketdataProviders = () => {
  return getAccountioSimple("marketdataproviders");
};

const getTradingPlatforms = () => {
  return getAccountioSimple("tradingplatforms");
};

const getAgreementTemplate = () => {
  return getAccountioSimple("documenttemplate");
};

const getAccountType = () => {
  return getAccountioSimple("accounttypes");
};

export const accountio = {
  getCalculationRates,
  getCountryRates,
  getMarketdataProviders,
  getTradingPlatforms,
  getAgreementTemplate,
  getCountries,
  getAccountType,
};
